import { createSlice } from '@reduxjs/toolkit';
import { createMediciens, getMedicienDetails, getMediciens, updateMediciens } from '.';

const initialState = {
	loading: false,

	mediciens: [],
	medicienDetails: null,
	totalMediciens: 0,
};

const mediciens = createSlice({
	name: 'mediciens',
	initialState,
	reducers: {
		resetMedicens: () => initialState,
		setMedicienDetails: (state, action) => {
			state.medicienDetails = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(getMediciens.pending, (state) => {
				state.loading = true;
			})
			.addCase(getMediciens.fulfilled, (state, action) => {
				state.loading = false;
				const { total, data } = action.payload.response.data.data;
				state.mediciens = data;
				state.totalMediciens = total;
			})
			.addCase(getMediciens.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(createMediciens.pending, (state) => {
				state.loading = true;
			})
			.addCase(createMediciens.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(createMediciens.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(updateMediciens.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateMediciens.fulfilled, (state) => {
				state.loading = false;
				state.medicienDetails = null;
			})
			.addCase(updateMediciens.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getMedicienDetails.pending, (state) => {
				state.loading = true;
			})
			.addCase(getMedicienDetails.fulfilled, (state, action) => {
				state.loading = false;
				state.medicienDetails = action.payload.response.data.data;
			})
			.addCase(getMedicienDetails.rejected, (state) => {
				state.loading = false;
			});
	}
});

export const { resetMedicens, setMedicienDetails } = mediciens.actions;

export default mediciens.reducer;